<app-page [simpleTopBar]="true" [showBottomBar]="false" [title]="title">
  <place-bid [post]="post" [postHashHex]="postHashHex" (changeTitle)="title = $event"></place-bid>
</app-page>
